import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { renderComponentField } from '@/shared/components/form/FormField';
import { colorFieldsBorder, colorText } from '@/utils/palette';
import { paddingLeft } from '@/utils/directions';

export const FileInputField = React.forwardRef(({ onChange, name, multiple, value }, ref) => {
  const handleChange = (e) => {
    e.preventDefault();
    onChange(e);
  };

  return (
    <FormGroupFile>
      <label htmlFor={name}>Choose the file</label>
      {value && <span>{value.name}</span>}
      <input
        type="file"
        name={name}
        id={name}
        onChange={handleChange}
        ref={ref}
        multiple={multiple}
      />
    </FormGroupFile>
  );
});

FileInputField.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      name: PropTypes.string,
    }),
    PropTypes.string,
  ]),
};

FileInputField.defaultProps = {
  value: null,
  multiple: false
};

export default renderComponentField(FileInputField);


// region STYLES

const FormGroupFile = styled.div`
  
  label {
    border-radius: 5px;
    line-height: 18px;
    font-size: 14px;
    padding: 10px 20px;
    cursor: pointer;
    transition: all 0.3s;
    text-align: center;
    border: 1px solid ${colorFieldsBorder};
    color: ${colorText};
    background: grey;

    &:hover {
      background: ${colorFieldsBorder};
    }
  }

  span {
    ${paddingLeft}: 10px;
  }

  input {
    display: none;
  }
`;

// endregion
